module.exports = __webpack_public_path__ + "./fonts/app.af3dacd9fd7b63e13ad5112148d7238c.eot";